import React from "react";
import img from "../../assets/images/stats.png";

const approachData = [
  {
    title: "Exceptional Quality & Precision",
    text: `Experience unparalleled excellence with our photobooth services, where we prioritize high-quality visuals and seamless operation. Our advanced equipment ensures that every photo is crisp and vibrant, while our attention to detail guarantees stunning clarity.`,
    delay: 100,
    shift: "xl:ml-0",
  },
  {
    title: "Efficient & Streamlined Service",
    text: `Maximize your event's success with our efficient photobooth setup and operation. We deliver a smooth, hassle-free experience that allows quick setup and seamless guest interactions.`,
    delay: 200,
    shift: "xl:ml-16",
  },
  {
    title: "Dedicated Customer Satisfaction",
    text: `We are committed to ensuring your complete satisfaction. Every detail is handled with care, making your experience stress-free and your event unforgettable.`,
    delay: 300,
    shift: "xl:ml-32",
  },
];

const Approach = () => {
  return (
    <section className="w-full px-4 py-24 max-w-[1400px] mx-auto">
      <div className="flex flex-col xl:flex-row items-center gap-16">
        {/* TEXT SIDE */}
        <div className="w-full xl:w-1/2 flex flex-col items-start">
          <p
            data-aos="fade-down"
            className="font-poppins text-[#76cfff] tracking-widest uppercase text-sm md:text-base font-bold mb-6"
          >
            Our Approach
          </p>

          <h1
            className="font-poppins text-white uppercase font-semibold text-left 
            text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-10"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            How We Deliver Exceptional Experiences
          </h1>

          <div className="flex flex-col gap-8 w-full">
            {approachData.map((item, idx) => (
              <div
                key={idx}
                data-aos="fade-up"
                data-aos-delay={item.delay}
                className={`
                  ${item.shift}
                  p-6 md:p-8 rounded-2xl
                  bg-white/5 backdrop-blur-xl
                  border border-white/10
                  shadow-[0_0_30px_rgba(118,207,255,0.08)]
                  hover:border-[#76cfff]/40
                  transition-all duration-300
                `}
              >
                <h4 className="font-poppins text-[#76cfff] uppercase font-semibold text-lg md:text-xl mb-4">
                  {item.title}
                </h4>
                <p className="font-poppins text-white/90 text-sm md:text-base font-light leading-relaxed tracking-wide">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* IMAGE SIDE */}
        <div
          className="
            hidden xl:flex w-full xl:w-[40%] aspect-[9/16]
            rounded-2xl overflow-hidden
            shadow-[0_0_40px_rgba(0,0,0,0.6)]
            flex items-center justify-center
          "
          data-aos="fade-left"
        >
          {/* ✅ lazy + async — below the fold, no need to block page load */}
          <img
            src={img}
            alt="Our approach stats"
            loading="lazy"
            decoding="async"
            fetchpriority="low"
            className="w-full h-1/2 object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Approach;